/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type RatelimitSetOverrideResponseData = {
  /**
   * The id of the override. This is used internally.
   */
  overrideId: string;
};

/** @internal */
export const RatelimitSetOverrideResponseData$inboundSchema: z.ZodType<
  RatelimitSetOverrideResponseData,
  z.ZodTypeDef,
  unknown
> = z.object({
  overrideId: z.string(),
});

/** @internal */
export type RatelimitSetOverrideResponseData$Outbound = {
  overrideId: string;
};

/** @internal */
export const RatelimitSetOverrideResponseData$outboundSchema: z.ZodType<
  RatelimitSetOverrideResponseData$Outbound,
  z.ZodTypeDef,
  RatelimitSetOverrideResponseData
> = z.object({
  overrideId: z.string(),
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace RatelimitSetOverrideResponseData$ {
  /** @deprecated use `RatelimitSetOverrideResponseData$inboundSchema` instead. */
  export const inboundSchema = RatelimitSetOverrideResponseData$inboundSchema;
  /** @deprecated use `RatelimitSetOverrideResponseData$outboundSchema` instead. */
  export const outboundSchema = RatelimitSetOverrideResponseData$outboundSchema;
  /** @deprecated use `RatelimitSetOverrideResponseData$Outbound` instead. */
  export type Outbound = RatelimitSetOverrideResponseData$Outbound;
}

export function ratelimitSetOverrideResponseDataToJSON(
  ratelimitSetOverrideResponseData: RatelimitSetOverrideResponseData,
): string {
  return JSON.stringify(
    RatelimitSetOverrideResponseData$outboundSchema.parse(
      ratelimitSetOverrideResponseData,
    ),
  );
}

export function ratelimitSetOverrideResponseDataFromJSON(
  jsonString: string,
): SafeParseResult<RatelimitSetOverrideResponseData, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RatelimitSetOverrideResponseData$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RatelimitSetOverrideResponseData' from JSON`,
  );
}
